import { render, staticRenderFns } from "./ImportDetailsModal.vue?vue&type=template&id=2c6aebc8&scoped=true"
import script from "./ImportDetailsModal.vue?vue&type=script&lang=js"
export * from "./ImportDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./ImportDetailsModal.vue?vue&type=style&index=0&id=2c6aebc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6aebc8",
  null
  
)

export default component.exports